import { InfoCircleTwoTone } from "@ant-design/icons";
import { Breadcrumb, Button, Drawer } from "antd";
import { BreadcrumbItemType } from "antd/es/breadcrumb/Breadcrumb";
import ErrorBoundary from "components/atoms/ErrorBoundary";
import React, { useState } from "react";
import { Link } from "react-router-dom";

type PageLayoutProps = {
    mainContent: (props: IPageLayoutMainContentProps) => React.ReactNode;
    helpContent?: React.ReactNode;
};

export default function PageLayout({ mainContent, helpContent }: PageLayoutProps) {
    const [breadcrumbNavigationItems, setBreadcrumbNavigationItems] = useState<IBreadcrumbItem[]>([]);

    const [showDrawer, setShowDrawer] = React.useState<boolean>(false);

    return (
        <div id="page-layout-new" className="flex flex-1 flex-col gap-2 overflow-auto">
            {breadcrumbNavigationItems.length > 0 && (
                <div className="bread-crumbs-container flex min-h-7 w-full flex-row items-center">
                    <div className="flex-auto">
                        <Breadcrumb
                            className="breadcrumb-item"
                            separator=">"
                            items={breadcrumbNavigationItems.reduce((acc, current) => {
                                acc.push({
                                    path: current.route,
                                    title: current.text,
                                });
                                return acc;
                            }, Array<BreadcrumbItemType>())}
                            itemRender={(currentRoute, _, items) => {
                                const isLast = currentRoute?.path === items[items.length - 1]?.path;
                                return isLast || !currentRoute.path ? <span>{currentRoute.title}</span> : <Link to={currentRoute.path}>{currentRoute.title}</Link>;
                            }}
                        />
                    </div>
                    {helpContent && (
                        <div className="flex-none">
                            <Button onClick={() => setShowDrawer(true)} size="small" icon={<InfoCircleTwoTone />}>
                                How To Use
                            </Button>
                        </div>
                    )}
                </div>
            )}
            <div id="page-layout-content-wrapper" className="flex size-full flex-1 flex-col overflow-auto">
                <div id="page-layout-content-area" className="flex size-full flex-1 flex-col overflow-auto">
                    <div className="relative flex size-full flex-1 flex-col gap-2 overflow-auto rounded-md border border-zinc-200 p-4">
                        <ErrorBoundary>
                            {mainContent({
                                setBreadcrumbNavigationItems,
                            })}
                        </ErrorBoundary>
                    </div>
                </div>
                {helpContent && (
                    <Drawer title="How To Use" open={showDrawer} onClose={() => setShowDrawer(false)}>
                        <div className="full-height-flex-container relative">
                            <ErrorBoundary>{helpContent}</ErrorBoundary>
                        </div>
                    </Drawer>
                )}
            </div>
        </div>
    );
}
